module.exports = new __parcel__URL__("logo-dark.ead71d45.webp").toString();